import React from 'react';
import { IconButton } from 'lib/@mui';
import { Edit } from 'lib/@mui/Icons';

import ExpressionDelete from '../../ExpressionsAddForm/ExpressionDelete';

import styles from './ExpressionItemInfo.module.scss';

const ExpressionItemActions = ({ name, handleEditClick, handleDeleteExpression }) => {
    return (
        <div className={styles.expressionItemActions}>
            <IconButton onClick={handleEditClick}>
                <Edit fontSize="large" color="primary" />
            </IconButton>
            <ExpressionDelete name={name} onDeleteExpression={handleDeleteExpression} />
        </div>
    );
};

export default ExpressionItemActions;
